import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Container } from '@/components/common/Container';
import { Section } from '@/components/common/Section';
import { theme } from '@/styles/theme';
//@ts-ignore
import mixScreenshot from '@/assets/screenshots/mix.png';
//@ts-ignore
import statsScreenshot from '@/assets/screenshots/stats.png';
//@ts-ignore
import themesScreenshot from '@/assets/screenshots/themes.png';

const DemoWrapper = styled(Section)`
  background: linear-gradient(135deg, ${theme.colors.primary.extraLight} 0%, ${theme.colors.secondary.warm} 100%);
  overflow: hidden;
`;

const Title = styled.h2`
  text-align: center;
  margin-bottom: ${theme.spacing.xxxl};
  color: ${theme.colors.text.black};
`;

const ScreenshotsWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: ${theme.spacing.xl};

  @media (max-width: ${theme.breakpoints.tablet}) {
    flex-direction: column;
    gap: ${theme.spacing.lg};
  }
`;

const Screenshot = styled(motion.img)`
  max-width: 280px;
  height: auto;
  border-radius: ${theme.borderRadius.large};
  box-shadow: ${theme.shadows.large};

  @media (max-width: ${theme.breakpoints.tablet}) {
    max-width: 240px;
  }
`;

const screenshots = [
  { src: mixScreenshot, alt: 'Word learning interface', delay: 0 },
  { src: statsScreenshot, alt: 'Progress statistics', delay: 0.1 },
  { src: themesScreenshot, alt: 'App themes', delay: 0.2 },
];

export const DemoSection = () => {
  return (
    <DemoWrapper $padding="large">
      <Container>
        <Title>A vocabulary app that feels as good as it looks</Title>
        <ScreenshotsWrapper>
          {screenshots.map((screenshot, index) => (
            <Screenshot
              key={index}
              src={screenshot.src}
              alt={screenshot.alt}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-100px' }}
              transition={{ duration: 0.4, delay: screenshot.delay }}
            />
          ))}
        </ScreenshotsWrapper>
      </Container>
    </DemoWrapper>
  );
};
